import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// Page de retour après l'authentification Google.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : "";
    (async () => {
      if (!sid) { navigate("/connexion", { replace: true }); return; }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        await refresh();
        const u = data.user || {};
        toast.success("Connexion réussie !");

        // Destination explicite mémorisée avant le login (ex. tunnel partenaire).
        let after = "";
        try { after = localStorage.getItem("google_after_login") || ""; localStorage.removeItem("google_after_login"); } catch {}
        if (after) { navigate(after, { replace: true }); return; }

        // Redirection selon le rôle.
        if (u.role === "admin" || u.role === "super_admin") { navigate("/admin", { replace: true }); return; }
        if (u.role === "professional") { navigate("/pro", { replace: true }); return; }
        if (u.role === "organization") { navigate("/organisme", { replace: true }); return; }
        if (u.role === "association") { navigate("/espace-association", { replace: true }); return; }
        if (u.role === "club") { navigate("/espace-club", { replace: true }); return; }

        // 1er login Google d'un bénéficiaire sans ville → on propose de compléter le profil.
        if (!(u.city || "").trim()) { navigate("/bienvenue-google", { replace: true }); return; }
        navigate("/compte", { replace: true });
      } catch {
        toast.error("Échec de la connexion Google. Réessayez.");
        navigate("/connexion", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] grid place-items-center text-slate-500" data-testid="google-callback">
      <div className="text-center">
        <Loader2 className="mx-auto h-8 w-8 animate-spin text-[#E05638]" />
        <p className="mt-3 text-sm">Connexion en cours…</p>
      </div>
    </div>
  );
}
